import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import CheckoutForm from './PaymentMethodForm'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_51JPA9rBRFvPifUzLKIhpQTk2z9NSE1QcnLPL2MeOtsQ16GvhqHkZbqMmVpqUp9ausznaWuDNi9jedyDw0AlIzIWQ00bpSD1qdQ');

const Stripes = ({ clientSecret, successCB, loadingCB }) => {
  const options = {
    // passing the client secret obtained from the server
    clientSecret: clientSecret,
  };
  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm successCB={successCB} loadingCB={loadingCB}/>
    </Elements>
  );
};

export default Stripes
